import type { ReactNode } from 'react'

import { Badge } from '@/components/ui/badge'

export const VAULT_TITLE = 'Compliance vault'

export const VAULT_SUBTITLE =
  'Monitored daily to prevent fines, violations, and accidental document expirations'

/** The page's name, the same on every vault state: before it opens, during setup, and after. */
export function VaultTitle({ aside, subtitle }: { aside?: ReactNode; subtitle?: boolean }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-x-6 gap-y-2">
      <div className="flex flex-col items-start gap-2">
        <Badge>New</Badge>
        <div className="flex flex-col gap-1">
          <h1 className="h3">{VAULT_TITLE}</h1>
          {/* Nothing is monitored until the vault is open, so the promise waits for it. */}
          {subtitle && <p className="text-muted-foreground max-w-2xl text-sm">{VAULT_SUBTITLE}</p>}
        </div>
      </div>
      {aside}
    </div>
  )
}
